"use strict"

import {observable, action} from "mobx"

class SignInLabDialogStore {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new SignInLabDialogStore()
export default singleton
